export const AnswerIcon = () => {
    return (
        <img 
            src="/favicon-blue.png" 
            alt="Videntis logo" 
            style={{ 
                width: '28px', 
                height: '28px',
                display: 'inline-block',
                verticalAlign: 'middle'
            }} 
            aria-label="Videntis logo"
        />
    );
};
